import React from "react";
import { Education } from "../types";

interface EducationSectionProps {
  education: Education[];
}

const EducationSection: React.FC<EducationSectionProps> = ({ education }) => {
  return (
    <section className="education-section section-padding" id="education">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 col-md-10 col-12 mx-auto">
            <div className="section-header text-center mb-5">
              <h2 className="section-title">Education</h2>
              <p className="section-subtitle">
                My academic background and educational achievements
              </p>
            </div>
            <div className="education-grid">
              {education.map((edu, index) => (
                <div key={index} className="education-item">
                  <div className="education-icon">
                    <i className="fas fa-graduation-cap"></i>
                  </div>
                  <div className="education-content">
                    <h3 className="degree-title">{edu.degree}</h3>
                    <p className="institution-name">{edu.institution}</p>
                    <span className="education-year">{edu.years}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EducationSection;
